import "./Logo.css";

export default function Logo({ game = "mk8dx" }) {
    const logoSrc = game === "world" 
        ? require("../../../assets/logos/Mario_Kart_World_logo.webp")
        : require("../../../assets/logos/Mario_Kart_8_Deluxe_logo.webp");
    
    const altText = game === "world"
        ? "Mario Kart World Logo"
        : "Mario Kart 8 Deluxe Logo";

    return (
        <div id="logo" className={`logo-${game}`}>
            <img className={game} src={logoSrc} alt={altText} />
            <h1>Cup Builder</h1>
        </div>
    );
}
